/**
 * mainNav
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_main-nav.scss';

// Module template
import './_main-nav.twig';

export const name = 'mainNav';

export function disable() {}

export function enable($context) {
  const $mainNav = $('.main-nav__wrapper', $context);

  // Toggle nav open/close
  $mainNav.on('click', '.main-nav__logo-wrapper', el => {
    $(el.delegateTarget).toggleClass('is-open');
  });
}

export default enable;
